import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function Textandfullscreenblock() {
  Alpine.data("textandfullscreenblock", () => ({
    init() {
      const media = this.$refs.media;
      if (!media) return;

      gsap.set(media, { scale: 1.15 });

      gsap.fromTo(
        media,
        { yPercent: -25 },
        {
          yPercent: 0,
          ease: "none",
          scrollTrigger: {
            trigger: this.$el,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        },
      );
    },
  }));
}
